module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [_c('swiper', {
    ref: "problemsPlasticKills",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgorange",
    attrs: {
      "id": "swiper-plastickill",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "full-title content-650"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _vm._l((_vm.slider), function(item, key) {
    return (item.title) ? _c('swiper-slide', [_c('div', {
      staticClass: "full-inner"
    }, [_c('div', {
      staticClass: "span-table text-left"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "content-650"
    }, [_c('h2', {
      staticClass: "full-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "entry-content pt1 content-500 left",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "item item-image full-image"
    }, [_c('img', {
      staticClass: "icon-slider",
      class: 'plastickills-' + key,
      attrs: {
        "src": '/static/images/whyplastic-slider-' + key + '.png',
        "alt": ""
      }
    })])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75c0ebce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Problems-plastickill.vue
// module id = 164
// module chunks = 1